import { render } from "./LocalLogin.vue?vue&type=template&id=33b7b232&scoped=true&ts=true"
import script from "./LocalLogin.vue?vue&type=script&lang=ts"
export * from "./LocalLogin.vue?vue&type=script&lang=ts"

import "./LocalLogin.vue?vue&type=style&index=0&id=33b7b232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b7b232"]])

export default __exports__